var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViolationReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 77,
    viewBox: "0 0 128 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.489 24.9325L108.724 23.1479L103.214 23.9488C102.397 24.0685 101.769 23.2291 102.126 22.476L103.076 20.4711C100.252 19.1327 99.2618 16.3578 100.6 13.5339L103.277 7.88614C104.616 5.06227 107.39 4.07197 110.214 5.4104L119.627 9.87182C122.451 11.2102 123.441 13.9851 122.103 16.809L119.426 22.4568C118.088 25.2806 115.313 26.2709 112.489 24.9325Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.934 16.0465L111.027 15.8488C111.331 15.2087 111.887 15.0573 112.412 14.9717C112.922 14.891 113.469 14.7351 113.763 14.1138C114.174 13.2478 113.807 12.2211 112.941 11.8107C112.075 11.4002 111.049 11.7667 110.638 12.6326",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.864 18.2942L109.873 18.2983",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7288 54.0971L21.6751 51.1509L27.133 50.0533C27.9433 49.8913 28.2527 48.8896 27.6634 48.3003L26.0945 46.7314C28.3042 44.5217 28.3042 41.5754 26.0945 39.3657L21.675 34.9463C19.4653 32.7366 16.519 32.7366 14.3093 34.9463L6.94364 42.312C4.73393 44.5217 4.73393 47.468 6.94364 49.6777L11.3631 54.0971C13.5728 56.3068 16.5191 56.3068 18.7288 54.0971Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2052 45.2056L17.0506 45.051C16.5497 44.5501 16.5939 43.9756 16.6897 43.4526C16.7854 42.9444 16.8222 42.3773 16.3361 41.8911C15.6584 41.2135 14.5683 41.2134 13.8907 41.8911C13.213 42.5687 13.2131 43.6589 13.8907 44.3365",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9682 46.963L18.9615 46.9696",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9068 38.2631V50.5789M68.9068 66.9999C59.5731 66.9999 54.9063 66.9999 52.2085 65.0398C49.8553 63.3302 48.3381 60.7023 48.0341 57.8096C47.6855 54.4932 50.0189 50.4516 54.6857 42.3684C59.3526 34.2852 61.686 30.2436 64.7324 28.8873C67.3896 27.7042 70.424 27.7042 73.0811 28.8873C76.1275 30.2436 78.461 34.2852 83.1278 42.3684C87.7946 50.4516 90.128 54.4932 89.7794 57.8096C89.4754 60.7023 87.9582 63.3302 85.605 65.0398C82.9072 66.9999 78.2404 66.9999 68.9068 66.9999Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9568 56.7367C70.9568 57.8703 70.0378 58.7893 68.9042 58.7893C67.7706 58.7893 66.8516 57.8703 66.8516 56.7367C66.8516 55.6031 67.7706 54.6841 68.9042 54.6841C70.0378 54.6841 70.9568 55.6031 70.9568 56.7367Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120 61L126 67M120 67L126 61",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28 72L32.2426 76.2426M28 76.2426L32.2426 72",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41 3L48 10M41 10L48 3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViolationReport);
export default __webpack_public_path__ + "static/media/violationReport.168bd2c5ab25ab8c8e1c36953f41aff3.svg";
export { ForwardRef as ReactComponent };